"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./Login.css");

var _react = _interopRequireDefault(require("react"));

var _MobxView = _interopRequireDefault(require("../../higher-order/MobxView"));

var _mobxReact = require("mobx-react");

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _LoginStore = _interopRequireDefault(require("../models/LoginStore.js"));

var _CustomInput = _interopRequireDefault(require("../../gradifui/components/form/CustomInput"));

var _CustomForm = _interopRequireDefault(require("../../gradifui/components/form/CustomForm"));

var _CustomPasswordInput = _interopRequireDefault(require("../../gradifui/components/form/CustomPasswordInput"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _Mouseflow = _interopRequireDefault(require("../../shared/components/Mouseflow"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _SessionPageContent = _interopRequireDefault(require("../components/SessionPageContent"));

var _SessionPageLogo = _interopRequireDefault(require("../components/SessionPageLogo"));

var _IENotSupportedBanner = _interopRequireDefault(require("../../shared/components/message/IENotSupportedBanner"));

var _constants = require("../../util/constants");

var _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var Login = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Login, _React$Component);

  var _super = _createSuper(Login);

  function Login() {
    _classCallCheck(this, Login);

    return _super.apply(this, arguments);
  }

  _createClass(Login, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _Mouseflow.default)();
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      e.preventDefault();
      this.props.dispatcher.emit("SUBMIT_LOGIN_FORM");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$session;

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_IENotSupportedBanner.default, null), /*#__PURE__*/_react.default.createElement(_SessionPageContent.default, null, /*#__PURE__*/_react.default.createElement(_SessionPageLogo.default, {
        baseAddress: (_this$props$session = this.props.session) === null || _this$props$session === void 0 ? void 0 : _this$props$session.baseAddress
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "content-header"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "h1",
        contentKey: "loginHeader",
        className: "user-login-header"
      })), /*#__PURE__*/_react.default.createElement(_CustomForm.default, {
        form: this.props.loginForm,
        onSubmit: this.handleSubmit,
        name: "loginForm",
        className: "user-login-form"
      }, /*#__PURE__*/_react.default.createElement(_CustomInput.default, {
        type: "email",
        placeholder: "Email",
        fieldName: "email",
        className: "no-mouseflow"
      }), /*#__PURE__*/_react.default.createElement(_CustomPasswordInput.default, {
        placeholder: "Password",
        fieldName: "password",
        showRequirements: false
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "a",
        contentKey: "forgotPassword",
        className: "forgot-password-link",
        href: _constants.URLS.RESET_PASSWORD
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "button",
        contentKey: "login",
        className: "user-login-submit-button"
      })), /*#__PURE__*/_react.default.createElement("section", {
        className: "support-section"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "h1",
        contentKey: "getStartedHeader",
        className: "get-started-header"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "a",
        contentKey: "getStarted",
        className: "get-started-link",
        href: _constants.URLS.GO
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "support"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "supportText1",
        className: "support-text-1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "supportText2",
        className: "support-text-2"
      })))));
    }
  }]);

  return Login;
}(_react.default.Component), (_applyDecoratedDescriptor(_class2.prototype, "handleSubmit", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleSubmit"), _class2.prototype)), _class2)) || _class;

var propulatedView = (0, _Propulator.default)(Login, {
  loginStore: ["loginForm"],
  sessionStore: ["session"]
});

var _default = (0, _MobxView.default)(propulatedView, {
  loginStore: _LoginStore.default
});

exports.default = _default;